import { create } from 'zustand';
var popup = create(function (set) { return ({
    showPopup: function (texts, buttons, handelBackPress) {
        set(function () { return ({
            popupInfo: {
                texts: texts,
                buttons: buttons,
                handelBackPress: handelBackPress,
            },
        }); });
    },
    hidePopup: function () {
        set(function () { return ({ popupInfo: null }); });
    },
}); });
export var usePopup = popup;
